import React from "react";
import { Link } from "react-router-dom";

function BreadCrumbHero({ pageTitle, pageSubTitle, linkText, linkUrl }) {
  return (
    <div className="pbmit-title-bar-wrapper pbmit-title-bar-style-1" style={{backgroundImage: "URL('assets/images/daily/v1.png')", backgroundPosition: "top center", backgroundRepeat: "no-repeat", backgroundSize: "cover"}}>
      <div className="container">
        <div className="pbmit-title-bar-content">
          <div className="pbmit-title-bar-content-inner">
            <div className="pbmit-tbar">
              <div className="pbmit-tbar-inner container">
                <h1 className="pbmit-tbar-title">{pageTitle}</h1>
              </div>
            </div>
            <div className="pbmit-breadcrumb">
              <div className="pbmit-breadcrumb-inner">
                <span>
                  <a title="" className="home">
                    <span>
                      <b>{pageSubTitle}</b>
                    </span>
                  </a>
                </span>
                <span>
                  <span className="post-root post post-post current-item">
                    {}
                  </span>
                </span>
              </div>
            </div>
            <br/>
            <Link to={linkUrl} className="pbmit-btn pbmit-btn-white m-2">
              <span className="button-text">{linkText}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BreadCrumbHero;
